export const spacing = {
  spacing_label_field: '8px',
  spacing_label_field_desktop: '12px',
  spacing_component: '16px',
  spacing_component_desktop: '24px',
}
